<div class="app-dialog-container participant-phone-call-is-verified-dialog">
    <div class="app-dialog-header">
        <div>
            <span class="app-dialog-header-text">{{isVerified ? 'Participant Authenticated' : 'Participant NOT Authenticated'}} </span>
            <i class="fas" 
            [ngClass]="[isVerified ? 'fa-check-circle' : 'fa-times-circle', isVerified ? 'participant-phone-call-is-verified-dialog-icon-verified' : 'participant-phone-call-is-verified-dialog-icon-unverified']"></i>
        </div>
    </div>
    <mat-dialog-content class="participant-phone-call-is-verified-dialog-dialog-content">
        <div *ngIf="isVerified">
            <span class="participant-phone-call-is-verified-dialog-participant-name">
                {{participantName | async}}
            </span>
            <span>
                has successfully been pre authenticated.
            </span>
        </div>
        <div *ngIf="!isVerified">
            <div class="participant-phone-call-is-verified-dialog-unverified-message-container">
                <div>
                    <span class="participant-phone-call-is-verified-dialog-participant-name">
                        {{participantName | async}}
                    </span>
                    <span>
                        has NOT been authenticated.
                    </span>
                </div>
                <div>
                    Identity verification is required before providing assistance.
                </div>
            </div>
            <div>
                <div class="participant-phone-call-is-verified-dialog-pii-header">
                    Employee Authentication Information
                </div>
                <div>
                    Date of Birth - {{(dateOfBirth | async) | date:'MM/dd/yyyy'}}
                </div>
                <div>
                    Last 4 SSN - {{ssnLastFour | async}}
                </div>
                <div>
                    Address - {{address | async}}
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button type="button" mat-flat-button color="primary" mat-dialog-close>
            OK
        </button>
    </mat-dialog-actions>
</div>